import { render } from "./ResetPassword.vue?vue&type=template&id=327c3c2b&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=ts"
export * from "./ResetPassword.vue?vue&type=script&lang=ts"

import "./ResetPassword.vue?vue&type=style&index=0&id=327c3c2b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-327c3c2b"

export default script